import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoClose } from "react-icons/io5";

const BudgetHeadModal = ({ open, onClose, onSave }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        budgetName: "",
        budgetAmount: "",
        budgetDate: ""
    });

    if (!open) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
        setFormData({ budgetName: "", budgetAmount: "", budgetDate: "" });
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl overflow-hidden">
                <div className="flex justify-between items-center bg-gray-50 px-6 py-3 border-b">
                    <h3 className="text-lg font-bold text-blue-800">{t('pageTitles.budgetHeadList')}</h3>
                    <button onClick={onClose} className="text-gray-500 hover:text-red-500"><IoClose size={24} /></button>
                </div>
                
                <form onSubmit={handleSubmit} className="p-8 space-y-6">
                    <div className="flex flex-col md:flex-row items-center gap-4">
                        <label className="w-full md:w-40 font-bold text-gray-700 text-right">{t('accounts.payment.budgetHead')}</label>
                        <span className="hidden md:inline font-bold">:</span>
                        <input 
                            type="text" 
                            className="flex-1 border-2 p-2 rounded-lg outline-none focus:border-blue-400"
                            placeholder="Enter Budget Name"
                            value={formData.budgetName}
                            onChange={e => setFormData({...formData, budgetName: e.target.value})}
                            required
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="flex items-center gap-4">
                            <label className="w-40 font-bold text-gray-700 text-right">{t('accounts.payment.budgetAmount')}</label>
                            <span className="font-bold">:</span>
                            <input 
                                type="number" 
                                className="flex-1 border-2 p-2 rounded-lg outline-none focus:border-blue-400"
                                placeholder="Enter Budget Amount"
                                value={formData.budgetAmount}
                                onChange={e => setFormData({...formData, budgetAmount: e.target.value})}
                                required
                            />
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="w-20 font-bold text-gray-700 text-right">{t('common.date')}</label>
                            <span className="font-bold">:</span>
                            <input 
                                type="date" 
                                className="flex-1 border-2 p-2 rounded-lg outline-none focus:border-blue-400"
                                value={formData.budgetDate}
                                onChange={e => setFormData({...formData, budgetDate: e.target.value})}
                                required
                            />
                        </div>
                    </div>

                    <div className="text-center pt-4">
                        <button type="submit" className="staff-btn-save">
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BudgetHeadModal;